import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// `ignoreRefs` lets callers register additional DOM nodes whose clicks should
// NOT be treated as "outside" — typically a toggle button rendered next to the
// handler that has its own onClick (e.g. the floating hamburger menu).
const OutsideClickHandler = ({ children, onOutsideClick, ignoreRefs }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handlePointerDown = event => {
      if (ref.current && ref.current.contains(event.target)) {return;}
      if (ignoreRefs) {
        const inIgnored = ignoreRefs.some(r => r && r.current && r.current.contains(event.target));
        if (inIgnored) {return;}
      }
      onOutsideClick(event);
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
    };
  }, [onOutsideClick, ignoreRefs]);

  return <div ref={ref}>{children}</div>;
};

OutsideClickHandler.propTypes = {
  children: PropTypes.node,
  onOutsideClick: PropTypes.func.isRequired,
  ignoreRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
};

export default OutsideClickHandler;
